import { render, staticRenderFns } from "./verifyDevice.vue?vue&type=template&id=10bd2b8e&scoped=true"
import script from "./verifyDevice.vue?vue&type=script&lang=js"
export * from "./verifyDevice.vue?vue&type=script&lang=js"
import style0 from "./verifyDevice.vue?vue&type=style&index=0&id=10bd2b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bd2b8e",
  null
  
)

export default component.exports